import React, { useMemo } from 'react';
import { shipFromSelectWidthStyle } from './shipFromLocationsUtils';

/**
 * Ship-from location dropdown with width sized to fit labels (avoids text under chevron).
 */
export default function AdminShipFromLocationSelect({
  id,
  value,
  onChange,
  options,
  title,
  className = '',
  'aria-label': ariaLabel,
  disabled = false,
}) {
  const wrapStyle = useMemo(() => shipFromSelectWidthStyle(options), [options]);

  return (
    <div className="admin-ship-from-select-wrap" style={wrapStyle}>
      <select
        id={id}
        className={`form-select form-select-sm admin-ship-from-location-select ${className}`.trim()}
        value={value}
        onChange={onChange}
        title={title}
        aria-label={ariaLabel}
        disabled={disabled}
      >
        {(options || []).map((o) => (
          <option key={o.id} value={o.id}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
